import { render, staticRenderFns } from "./list4gFp.vue?vue&type=template&id=138117d9&scoped=true&"
import script from "./list4gFp.vue?vue&type=script&lang=js&"
export * from "./list4gFp.vue?vue&type=script&lang=js&"
import style0 from "./list4gFp.vue?vue&type=style&index=0&id=138117d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138117d9",
  null
  
)

component.options.__file = "list4gFp.vue"
export default component.exports